<template>
    <div class="page login2 login-page">
        <div class="title-text">
            登录
        </div>
        <!-- <div class="input-card">
            <van-field class="input-style" v-model="user.loginAccount" center clearable placeholder="请输入账号"
                input-align="center" :border="false" />
            <van-field class="input-style" v-model="user.password" center clearable placeholder="请输入密码" type="password"
                input-align="center" :border="false" />
            <div class="login-buttons">
                <van-button type="default" round class="default-button" @click="dialogShow = true">账号注册</van-button>
                <van-button type="primary" @click="login" round class="primary-button">立即登录</van-button>
            </div>
        </div> -->

        <div class="login-form">
          <van-form :show-error="false" @submit="login">
            <van-field
              v-model="user.loginAccount"
              left-icon="contact"
              name="用户名"
              placeholder="手机号/账号"
              :rules="[{ required: true, message: '请填写手机号/账号' }]"
            />
            <van-field
              v-model="password"
              left-icon="closed-eye"
              type="password"
              name="账号密码"
              placeholder="账号密码"
              :rules="[{ required: true, message: '请填写账号密码' }]"
            />
            <div style="margin: 16px;">
              <van-button type="primary" native-type="submit" round class="login-button">立即登录</van-button>
            </div>
          </van-form>
        </div>

        <div class="operation-box">
          <div  @click="dialogShow = true">注册</div>
          <div @click="handleForgetPassword">忘记密码？</div>
        </div>

        <div class="block"></div>

        <div class="bottom">
            <van-divider :style="{ color: 'lightgray', borderColor: 'lightgray', padding: '0 16px', fontSize: '12px' }">
                其他登陆
            </van-divider>
            <div class="other-login">
                <div @click="ciamLogin()" >手机验证码登陆</div>
                <!-- <div  >开思</div>
                <div  >康众</div> -->
            </div>
            <div class="agree-line">
                <van-checkbox checked-color="#00545e" v-model="isAgree">
                    <p class="agree-text">我已阅读并同意<span @click="gotoWeb('site-agreement')">《平台协议》</span><span  @click="gotoWeb('privacy')">《隐私协议》</span></p>
                </van-checkbox>
            </div>

        </div>
        <van-dialog v-model="dialogShow" title="请选择您的身份" :show-confirm-button="false" :close-on-click-overlay="true">
            <div class="dialog">
                <van-button type="primary" round class="primary-button" @click="toRegister('01')">我是老板</van-button>
                <van-button type="primary" round class="primary-button" @click="toRegister('04')">我是员工</van-button>
            </div>
        </van-dialog>

        <van-dialog v-model="selectDialog" title="该手机号对应多个修理厂，请选择修理厂" show-cancel-button @confirm="handleLogin()">
            <div class="select-dialog">
                <van-radio-group v-model="clientId">
                    <van-cell-group inset>
                        <van-cell v-for="item of clientList" :key="item.clientId" :title="item.clientName" clickable @click="checked = '1'">
                        <template #right-icon>
                            <van-radio checked-color="#00545e" :name="item.clientId" />
                        </template>
                        </van-cell>
                    </van-cell-group>
                </van-radio-group>
            </div>
        </van-dialog>
        <ReturnToLogin ref="ReturnToLogin" @after-confirm="handleJumpHome"></ReturnToLogin>
    </div>
</template>

<script>
import wxAppApi from '@/api/wx-app'
import { cryptoUtils } from '@/utils/common'
import { userUtils } from '@/utils/auth'
import ReturnToLogin from '@/views/activity/components/return-to-login.vue'
export default {
  components: {
    ReturnToLogin
  },
  data () {
    return {
      user: {
        loginAccount: '',
        password: ''
      },
      isAgree: false,
      dialogShow: false,
      selectDialog: false,
      clientList: [],
      clientId: '',
      password: '',
      isPick: '',
      redirectUrl: 'home-main'
    }
  },
  created () {
    this.user.loginAccount = this.$route.query.contactMobile || ''
    this.clientId = this.$route.query.clientId || ''
    this.isPick = this.$route.query.pickStar
    this.redirectUrl = this.$route.params.redirectUrl || 'home-main'
  },
  methods: {
    toRegister (applyType) {
      // 01 店主; 04员工
      this.$router.push({
        path: '/register2',
        query: {
          applyType
        }
      })
    },
    login () {
      if (!this.isAgree) {
        this.$toast('请阅读并同意《网站协议》和《隐私条款》！')
        return
      }
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        mask: true,
        message: '登录中'
      })
      let isRemember = Number(this.isAutoLogin)
      let password = cryptoUtils.AESEncrypt(this.password)
      this.user = {
        loginAccount: this.user.loginAccount,
        password: password,
        isRemember
      }
      wxAppApi
        .authLoginClientQuery(this.user)
        .then(res => {
          this.$toast.clear()
          if (res.data.resultCode === '0') {
            if (res.data.resultData && res.data.resultData.clientList) {
              this.clientList = res.data.resultData.clientList
              this.selectDialog = true
            } else {
              this.handleLogin()
            }
          }
        })
        .catch(() => {
          this.$toast.clear()
        })
    },
    handleLogin () {
      this.user.clientId = this.clientId
      wxAppApi
        .authLogin(this.user)
        .then(res => {
          this.$toast.clear()
          if (res.data.resultCode === '0') {
            userUtils.setUserLocal(res.data.resultData)
            if (res.data.resultData.needChangePassword === 1) {
              this.$router.push({ name: 'forget-password', query: { loginStatus: true } })
              return
            }
            if (res.data.resultData.activityCoinDTO) {
              // 回归活动
              this.$refs['ReturnToLogin'] && this.$refs['ReturnToLogin'].open(res)
            } else {
              this.handleJumpHome(res)
            }
          }
        })
        .catch(() => {
          this.$toast.clear()
        })
    },
    // 正常登录逻辑
    handleJumpHome (res) {
      if (localStorage.getItem('oldfullPath') && res.data.resultData.clientInfo.clientId) {
        var oldfullPath = JSON.parse(localStorage.getItem('oldfullPath'))
        var clientId = res.data.resultData.clientInfo.clientId
        console.log('clientId===', clientId)
        console.log('11oldfullPath===', oldfullPath)
        if (clientId == oldfullPath.clientId) {
          this.$router.push({ name: oldfullPath.fullPath })
          localStorage.setItem('oldfullPath', '')
          return
        }
      }
      if (res.data.resultData.clientInfo.isActivated === 0) {
        this.$router.push({ name: 'activation_step_one' })
        return
      }
      if (this.isPick === 1) {
        this.$router.push({ name: 'activity-star-pick' })
      } else {
        // this.$router.push({ name: 'home-main' })
        if (this.redirectUrl === 'home-main') {
          this.$router.replace({ name: 'home-main' })
          localStorage.setItem('lastLoginTime', res.data.resultData.lastLoginTime || '')
        } else {
          this.$router.replace({ name: this.redirectUrl })
        }
      }
      // if (this.fromSource) {
      //   this.$router.push({ name: this.redirectUrl, query: { type: this.type, fromSource: this.$route.query.fromSource } })
      // } else {
      //   this.$router.replace({ name: this.redirectUrl })
      // }
    },
    handleForgetPassword () {
      this.$router.push({ name: 'forget-password' })
    },
    ciamLogin () {
      window.location = window.location.origin + '/v2/ciam/login'
    },
    gotoWeb (name) {
      this.$router.push({ name })
    }
  }
}
</script>
<style lang="less" scoped>
.login2 {
    height: 100%;
    min-height: 700px;
    width: 100%;
    box-sizing: border-box;
    // color: var(--base-green);
    background: rgb(241, 241, 241);
    padding-left: 20px;
    padding-right: 20px;
    .title-text {
        font-size: 24px;
        margin-bottom: 16px;
        font-weight: bold;
    }

    .input-card {
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
        padding: 20px;
        border-radius: 16px;

        .input-style {
            border-radius: 30px;
            background: var(--base-light-green);
            margin-bottom: 16px;

        }

        .login-buttons {
            display: flex;
            align-items: center;
            margin-top: 32px;
            margin-bottom: 8px;

            .default-button {
                flex: 1;
                color: var(--base-green);
                border: 1px solid var(--base-green);
                margin-right: 16px;
            }

            .primary-button {
                flex: 1;
                margin-left: 16px;
            }
        }
    }

    .block{
      width: 100%;
      height: calc(100vh - 46px - 490px);
    }

    .bottom {
        width: 100%;
        margin-bottom: 20px;
    }

    .other-login {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        margin-bottom: 36px;

        div {
          padding: 5px 10px;
          height: 18px;
          line-height: 18px;
          font-size: 12px;
            text-align: center;
            color: var(--base-green);
            border: 1px solid var(--base-green);
            border-radius: 5px;
        }
    }

    .agree-line {
        padding: 0px 32px;
        display: flex;

        .agree-text {
            color: lightgray;
            font-size: 12px;

            span {
                color: var(--base-blue)
            }
        }
    }

    .dialog {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 16px;

        .primary-button {
            width: 100%;
            margin-bottom: 16px;
        }
    }
    .select-dialog{
        margin: 10px 0;
        overflow: auto;
        max-height: 200px;
    }
    .login-button{
      width: 100%;
    }
}
.login-form{
  margin-top: 40px;
}
.operation-box{
  width: 90%;
  margin-left: 5%;
  margin-top: 20px;
  color: grey;
  display: flex;
  justify-content: space-between;
}
</style>
